export function mexicoToday() {
    return new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString().slice(0, 10)
}

export function dayFromHash() {
    const qs = window.location.hash.split('?')[1] || ''
    const day = new URLSearchParams(qs).get('day')
    return /^\d{4}-\d{2}-\d{2}$/.test(day || '') ? day : mexicoToday()
}

export function shiftIsoDay(day, delta) {
    const [year, month, date] = String(day || '').split('-').map(Number)
    if (!year || !month || !date) return day
    return new Date(Date.UTC(year, month - 1, date + delta)).toISOString().slice(0, 10)
}
